<template>
  <b-form-group :label="label">
    <b-form-input
      :placeholder="placeholder || `Enter ${label}`"
      :type="type"
      :value="value"
      @input="onInput"
    >
    </b-form-input>
    <span v-if="error" class="text-danger">
      {{ error }}
    </span>
  </b-form-group>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: String,
      required: true,
    },
    error: {
      type: Object,
    },
  },
  methods: {
    onInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>
